import React from 'react';
import './ComplaintShimmer.css';

const ComplaintShimmer = () => (
  <div className="page-content">
    {/* MetaTags shimmer (not visible, but for structure) */}
    <div className="shimmer shimmer-meta" style={{ height: 0 }}></div>
    <div className="container-fluid">
      {/* Breadcrumb shimmer */}
      <div className="shimmer shimmer-breadcrumb mb-4" style={{ width: '20%', height: 32 }}></div>
      <div className="row align-items-start border-bottom border-top px-3 py-4 mb-0 row bg-light border-secondary-subtle">
        <div className="col-md-9 border-3 border-end py-4">
          <div className="row">
            <div className="col-md-9">
              <div className="d-flex align-items-center gap-3">
                <div className="progressCircle p10 shimmer-progress" style={{ width: 60, height: 60, borderRadius: '50%', position: 'relative', background: '#f6f7f8' }}>
                  <span className="shimmer shimmer-progress-text" style={{ width: 28, height: 16, display: 'block', margin: '0 auto', position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', borderRadius: 4 }}></span>
                  <div className="leftHalfClipper" style={{ position: 'absolute', width: '100%', height: '100%', left: 0, top: 0 }}>
                    <div className="first50Bar shimmer" style={{ position: 'absolute', width: '50%', height: '100%', left: 0, top: 0, borderTopLeftRadius: '50%', borderBottomLeftRadius: '50%' }}></div>
                    <div className="valueBar shimmer" style={{ position: 'absolute', width: '50%', height: '100%', right: 0, top: 0, borderTopRightRadius: '50%', borderBottomRightRadius: '50%' }}></div>
                  </div>
                </div>
                <div className="d-flex flex-column gap-2">
                  <h5 className="mb-1 fw-semibold shimmer" style={{ width: '60%', height: 20 }}></h5>
                  <p className="m-0 shimmer" style={{ width: '40%', height: 16 }}></p>
                  <p className="text-muted m-0 shimmer" style={{ width: '30%', height: 16 }}></p>
                  <div className="d-flex flex-row gap-2 align-items-center">
                    <span className="badge shimmer rounded-pill fw-semibold d-flex align-items-center gap-1 p-1" style={{ width: 80, height: 24 }}></span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="col-md-3 py-4">
          <div className="d-flex flex-column gap-2 px-4">
            <h5 className="mb-2 fw-semibold shimmer" style={{ width: '50%', height: 20 }}></h5>
            <div className="d-flex flex-row gap-2">
              <div className="rounded-circle border bg-soft-light d-flex align-items-center justify-content-center fw-semibold text-secondary mb-auto shimmer" style={{ width: 50, height: 50 }}></div>
              <div className="d-flex flex-column gap-2">
                <p className="m-0 text-muted shimmer" style={{ width: '60%', height: 16 }}></p>
                <p className="m-0 text-muted shimmer" style={{ width: '40%', height: 16 }}></p>
                <p className="m-0 text-muted shimmer" style={{ width: '50%', height: 16 }}></p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="row px-3 py-4">
        {/* Left Panel (Complaint Status) */}
        <div className="col-md-3 border-2 border-end">
          <div className="p-4">
            <h4 className="fw-semibold mb-3 shimmer" style={{ width: '60%', height: 20 }}></h4>
            <div className="ps-5 d-flex flex-column">
              {[...Array(7)].map((_, i) => (
                <div key={i} className="position-relative mb-3">
                  <div className="position-absolute rounded-circle d-flex align-items-center justify-content-center text-white bg-soft-success shimmer" style={{ width: 22, height: 22, left: -10, top: -3 }}></div>
                  <div className="ps-4 pb-4" style={{ borderLeft: '2px solid #92cc7c' }}>
                    <strong className="shimmer mb-1" style={{ width: '40%', height: 16, display: 'block' }}></strong>
                    <p className="mb-0 text-muted small shimmer" style={{ width: '60%', height: 12 }}></p>
                    <small className="text-muted shimmer" style={{ width: '30%', height: 10 }}></small>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
        {/* Center Panel */}
        <div className="col-md-6 border-3 border-end">
          <div className="p-4">
            {/* Complaint Remark Section */}
            <div className="bg-soft-light p-4 rounded-3 mb-4 border">
              <div className="d-flex flex-row align-items-center gap-3 border-bottom pb-2 mb-4">
                <div className="rounded-circle border bg-soft-light d-flex align-items-center justify-content-center fw-semibold text-secondary mb-auto shimmer" style={{ width: 50, height: 50 }}></div>
                <div>
                  <h5 className="shimmer mb-1" style={{ width: '60%', height: 20 }}></h5>
                  <p className="text-muted shimmer" style={{ width: '40%', height: 16 }}></p>
                </div>
                <span className="badge bg-soft-dark text-dark rounded-pill fw-semibold d-flex align-items-center gap-1 p-1 ms-auto shimmer" style={{ width: 80, height: 24 }}></span>
              </div>
              <p className="shimmer" style={{ width: '100%', height: 32 }}></p>
            </div>
            {/* Public Note Section */}
            <div className="bg-soft-light p-4 rounded-3 mb-4 border">
              <div className="d-flex flex-row align-items-center gap-3 border-bottom pb-2 mb-4">
                <div className="rounded-circle border bg-soft-light d-flex align-items-center justify-content-center fw-semibold text-secondary mb-auto shimmer" style={{ width: 50, height: 50 }}></div>
                <div>
                  <h5 className="shimmer mb-1" style={{ width: '60%', height: 20 }}></h5>
                  <p className="text-muted shimmer" style={{ width: '40%', height: 16 }}></p>
                </div>
                <span className="badge bg-soft-dark text-dark rounded-pill fw-semibold d-flex align-items-center gap-1 p-1 ms-auto shimmer" style={{ width: 80, height: 24 }}></span>
              </div>
              <p className="shimmer" style={{ width: '100%', height: 32 }}></p>
              <p className="shimmer" style={{ width: '100%', height: 24 }}></p>
              <p className="shimmer" style={{ width: '100%', height: 24 }}></p>
            </div>
          </div>
        </div>
        {/* Right Panel */}
        <div className="col-md-3">
          <div className="p-4 pe-0">
            <h4 className="fw-semibold mb-3 shimmer" style={{ width: '60%', height: 20 }}></h4>
            <div className="d-flex flex-wrap gap-2">
              {[...Array(3)].map((_, i) => (
                <div key={i} className="bg-light border border-1 border-secondary-subtle rounded shimmer" style={{ width: 80, height: 80 }}></div>
              ))}
            </div>
          </div>
          <div className="p-4 pe-0">
            <h4 className="shimmer" style={{ width: '40%', height: 20 }}></h4>
            <div className="d-flex flex-wrap gap-3 w-100">
              <div className="form-group w-100 shimmer" style={{ height: 40, marginBottom: 8 }}></div>
              <div className="form-group w-100 shimmer" style={{ height: 60, marginBottom: 8 }}></div>
              <button className="btn btn-success ms-auto shimmer" style={{ width: 100, height: 36 }}></button>
            </div>
          </div>
        </div>
      </div>
      {/* <ReturnOrderDetails  orderData={orderData} itemData={itemData}/>  */}
    </div>
  </div>
);

export default ComplaintShimmer;
